import {configureStore, Middleware} from '@reduxjs/toolkit';
import {persistReducer, persistStore} from 'redux-persist';
// import encryptTransform from 'redux-persist-transform-encrypt';
import storage from 'redux-persist/lib/storage';
import {PERSIST_STORE_NAME} from '../global/constants/app.constants';
import rootReducer, {RootState} from './rootReducer';

const middlewares: Middleware[] = [];

const persistConfig = {
    key: PERSIST_STORE_NAME,
    keyPrefix: '',
    storage,
    whitelist: ['session', 'configurations', 'drawer', 'myWork'],
    // transforms: [
    //     encryptTransform({
    //         secretKey: PERSIST_STORE_ENCRYPTION_KEY,
    //         onError: function () {
    //             // Handle the error.
    //         },
    //     }),
    // ],
};
const store = configureStore({
    reducer: persistReducer<RootState>(persistConfig, rootReducer()),
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            immutableCheck: true,
            serializableCheck: false,
        }).concat(middlewares),
    // devTools: process.env.NODE_ENV !== "prod",
});

export type AppRootState = ReturnType<typeof store.getState>;
export type AppDispatchType = typeof store.dispatch;
export const persistor = persistStore(store);

export default store;
